export const getCurrentLocale = (locale) => {
    switch (locale) {
        case "nl_NL":
            return "nl";
        case "nl_BE":
            return "be";
        case "fr_FR":
            return "fr";
        default:
            return locale;
    }
};

export const isMultiLanguageSite = () => {
    if (window.location.host.includes("zomerjobs")) {
        return true;
    }

    if (window.location.host.includes("topanimation")) {
        return true;
    }

    if (window.location.host.includes("collaborer")) {
        return true;
    }

    if (window.location.host.includes("samenwerken")) {
        return true;
    }

    return false;
};

export const buildApiUrlBasedOnCollection = (collectionType, parameters, locale) => {
    const url = `api/collections/${collectionType}/entries`;

    const currentUrl = new URL(`${window.location.origin}/${url}`);

    parameters.map((item) => {
        currentUrl.searchParams.append(item.key, item.value);

        return item;
    });

    if (isMultiLanguageSite()) {
        currentUrl.searchParams.append("filter[site]", getCurrentLocale(locale));
    }

    return currentUrl;
};
